import { createReducer } from '@reduxjs/toolkit';
import { saveKeyFeatureScreenShot } from 'actionCreators/screenshot';

const screenShotReducer = createReducer({
  keyFature: null,
  loanAgreement: null
}, (builder) => {
  builder.addCase(saveKeyFeatureScreenShot, (state, action) => {
    return {
      ...state,
      keyFature: action.payload
    };
  });
});

export { screenShotReducer };
